// Mock data for Factor clickable prototype.
// All data is static and lives in-memory only.

export const OWNERS = [
  {
    id: "own-01",
    name: "Núria Vidal",
    company: "Vidal Holdings S.L.",
    email: "nuria@vidalholdings.es",
    phone: "+34 612 340 981",
  },
  {
    id: "own-02",
    name: "Marcus Weber",
    company: "Weber Portfolio GmbH",
    email: "m.weber@weber-portfolio.de",
    phone: "+49 170 8823 442",
  },
  {
    id: "own-03",
    name: "Elena Serra",
    company: "Serra Rentals",
    email: "elena@serrarentals.com",
    phone: "+34 655 902 118",
  },
];

export const PROPERTIES = [
  {
    id: "prop-01",
    name: "Casa Bellver",
    ownerId: "own-01",
    address: "Carrer de Bellver 24",
    city: "Palma",
    country: "Mallorca",
    reference: "ETV/12/2019",
    bedrooms: 4,
    capacity: 8,
    operationalStatus: "Active",
    complianceStatus: "current",
    openActions: 0,
    nextExpiryDate: "2026-11-14",
    requirementCounts: { current: 6, expiring: 0, missing: 0, total: 6 },
  },
  {
    id: "prop-02",
    name: "Villa Deià",
    ownerId: "own-01",
    address: "Camí des Ribassos 8",
    city: "Deià",
    country: "Mallorca",
    reference: "ETV/44/2021",
    bedrooms: 5,
    capacity: 10,
    operationalStatus: "Active",
    complianceStatus: "expiring",
    openActions: 2,
    nextExpiryDate: "2026-03-02",
    requirementCounts: { current: 4, expiring: 2, missing: 0, total: 6 },
  },
  {
    id: "prop-03",
    name: "Finca Son Verí",
    ownerId: "own-02",
    address: "Camí Son Verí 112",
    city: "Llucmajor",
    country: "Mallorca",
    reference: "ETV/89/2020",
    bedrooms: 6,
    capacity: 12,
    operationalStatus: "Active",
    complianceStatus: "action",
    openActions: 3,
    nextExpiryDate: "2026-02-18",
    requirementCounts: { current: 3, expiring: 1, missing: 2, total: 6 },
  },
  {
    id: "prop-04",
    name: "Apartamento Santa Eulària",
    ownerId: "own-02",
    address: "Avinguda Espanya 47, 3B",
    city: "Santa Eulària des Riu",
    country: "Ibiza",
    reference: "VT/17/2022",
    bedrooms: 2,
    capacity: 4,
    operationalStatus: "Active",
    complianceStatus: "current",
    openActions: 0,
    nextExpiryDate: "2027-01-30",
    requirementCounts: { current: 6, expiring: 0, missing: 0, total: 6 },
  },
  {
    id: "prop-05",
    name: "Can Portinatx",
    ownerId: "own-03",
    address: "Carrer des Molí 3",
    city: "Sant Joan de Labritja",
    country: "Ibiza",
    reference: "VT/03/2023",
    bedrooms: 3,
    capacity: 6,
    operationalStatus: "Onboarding",
    complianceStatus: "incomplete",
    openActions: 4,
    nextExpiryDate: null,
    requirementCounts: { current: 1, expiring: 0, missing: 3, total: 6 },
  },
  {
    id: "prop-06",
    name: "Villa Es Cubells",
    ownerId: "own-03",
    address: "Camí Vell des Cubells 9",
    city: "Sant Josep de sa Talaia",
    country: "Ibiza",
    reference: "VT/22/2021",
    bedrooms: 5,
    capacity: 10,
    operationalStatus: "Active",
    complianceStatus: "expiring",
    openActions: 1,
    nextExpiryDate: "2026-04-11",
    requirementCounts: { current: 5, expiring: 1, missing: 0, total: 6 },
  },
];

export const REQUIREMENT_TYPES = [
  { id: "rt-01", name: "Rental licence", category: "Licensing" },
  { id: "rt-02", name: "Tourism registration", category: "Registration" },
  { id: "rt-03", name: "Liability insurance", category: "Insurance" },
  { id: "rt-04", name: "Fire safety certificate", category: "Safety" },
  { id: "rt-05", name: "Homeowners association approval", category: "Approvals" },
  { id: "rt-06", name: "Tax registration", category: "Tax" },
];

// Build a full requirements list — 6 requirements per property (36 total)
const AUTHORITIES = {
  "Rental licence": "Consell Insular",
  "Tourism registration": "Direcció General de Turisme",
  "Liability insurance": "MAPFRE Empresas",
  "Fire safety certificate": "Bombers de Balears",
  "Homeowners association approval": "Comunitat de Propietaris",
  "Tax registration": "Agència Tributària",
};

// helper to seed varied statuses per property
function reqStatusFor(prop, typeIdx) {
  // deterministic pattern based on property complianceStatus
  const map = {
    current: ["current", "current", "current", "current", "current", "current"],
    expiring: ["current", "expiring", "current", "current", "expiring", "current"],
    action: ["current", "expiring", "missing", "current", "missing", "current"],
    incomplete: ["current", "missing", "missing", "missing", "current", "current"],
  };
  return map[prop.complianceStatus][typeIdx];
}

function issueDateFor(status, i) {
  if (status === "missing") return null;
  const base = new Date(2024, 6, 1 + i * 3);
  return base.toISOString().slice(0, 10);
}

function expiryDateFor(status, i) {
  if (status === "missing") return null;
  if (status === "expiring") {
    const d = new Date();
    d.setDate(d.getDate() + 12 + i * 3);
    return d.toISOString().slice(0, 10);
  }
  const base = new Date(2027, 3, 5 + i * 4);
  return base.toISOString().slice(0, 10);
}

export const REQUIREMENTS = PROPERTIES.flatMap((prop) =>
  REQUIREMENT_TYPES.map((rt, i) => {
    const status = reqStatusFor(prop, i);
    return {
      id: `${prop.id}-${rt.id}`,
      propertyId: prop.id,
      typeId: rt.id,
      name: rt.name,
      category: rt.category,
      status,
      referenceNumber:
        status === "missing" ? null : `${rt.name.slice(0, 3).toUpperCase()}-${prop.id.slice(-2)}-${1000 + i * 7}`,
      issueDate: issueDateFor(status, i),
      expiryDate: expiryDateFor(status, i),
      authority: AUTHORITIES[rt.name],
      notes:
        status === "missing"
          ? "Information incomplete — awaiting submission from owner."
          : status === "expiring"
          ? "Renewal approaching. Prepare submission at least 21 days before expiry."
          : "All registered requirements are current.",
      linkedDocumentIds: status === "missing" ? [] : [`doc-${prop.id}-${rt.id}`],
      responsibleContactId:
        i % 2 === 0 ? "con-01" : i % 3 === 0 ? "con-02" : "con-03",
    };
  })
);

export const DOCUMENTS = REQUIREMENTS.filter((r) => r.linkedDocumentIds.length > 0).map(
  (r) => {
    const prop = PROPERTIES.find((p) => p.id === r.propertyId);
    return {
      id: `doc-${r.propertyId}-${r.typeId}`,
      name: `${r.name.replace(/\s+/g, "_")}_${prop.reference.replace(/\//g, "-")}.pdf`,
      type: r.category,
      propertyId: r.propertyId,
      requirementId: r.id,
      uploadedAt: r.issueDate || "2025-08-14",
      expiryDate: r.expiryDate,
      sizeKb: 220 + ((r.name.length * 37) % 900),
      status: r.status,
    };
  }
);

export const CONTACTS = [
  {
    id: "con-01",
    name: "Aina Ferrer",
    role: "Compliance Manager",
    company: "Factor Operations",
    email: "aina.ferrer@factor.ops",
    phone: "+34 671 220 019",
    linkedPropertyIds: ["prop-01", "prop-02", "prop-06"],
  },
  {
    id: "con-02",
    name: "Joan Salom",
    role: "Insurance Broker",
    company: "MAPFRE Empresas",
    email: "joan.salom@mapfre.es",
    phone: "+34 971 442 018",
    linkedPropertyIds: ["prop-01", "prop-03", "prop-05"],
  },
  {
    id: "con-03",
    name: "Sofia Grau",
    role: "Tourism Registrar",
    company: "Direcció General de Turisme",
    email: "s.grau@dgturisme.gob.es",
    phone: "+34 971 178 400",
    linkedPropertyIds: ["prop-02", "prop-04", "prop-06"],
  },
  {
    id: "con-04",
    name: "Lluís Bonet",
    role: "Fire Safety Inspector",
    company: "Bombers de Balears",
    email: "l.bonet@bombers.bal",
    phone: "+34 971 550 022",
    linkedPropertyIds: ["prop-03", "prop-05"],
  },
  {
    id: "con-05",
    name: "Carla Riera",
    role: "Tax Advisor",
    company: "Riera Fiscal",
    email: "carla@rierafiscal.com",
    phone: "+34 617 003 220",
    linkedPropertyIds: ["prop-01", "prop-02", "prop-03", "prop-04", "prop-05", "prop-06"],
  },
];

export const JURISDICTIONS = [
  { id: "jur-01", name: "Illes Balears — Mallorca", country: "Spain", requirementCount: 6 },
  { id: "jur-02", name: "Illes Balears — Ibiza", country: "Spain", requirementCount: 6 },
  { id: "jur-03", name: "Catalunya — Barcelona", country: "Spain", requirementCount: 5 },
  { id: "jur-04", name: "Canarias — Tenerife", country: "Spain", requirementCount: 5 },
];

export const USERS = [
  { id: "usr-01", name: "Aina Ferrer", email: "aina.ferrer@factor.ops", role: "Admin", lastActive: "2 hours ago" },
  { id: "usr-02", name: "Marc Coll", email: "marc.coll@factor.ops", role: "Operator", lastActive: "Yesterday" },
  { id: "usr-03", name: "Rita Puig", email: "rita.puig@factor.ops", role: "Viewer", lastActive: "3 days ago" },
  { id: "usr-04", name: "Núria Vidal", email: "nuria@vidalholdings.es", role: "Owner", lastActive: "1 week ago" },
];

// KPI helpers
export function getKPIs() {
  const total = PROPERTIES.length;
  const current = PROPERTIES.filter((p) => p.complianceStatus === "current").length;
  const requiringAction = PROPERTIES.filter(
    (p) => p.complianceStatus === "action" || p.complianceStatus === "incomplete"
  ).length;

  const now = new Date();
  const in30 = new Date();
  in30.setDate(now.getDate() + 30);
  const expiringSoon = REQUIREMENTS.filter((r) => {
    if (!r.expiryDate) return false;
    const d = new Date(r.expiryDate);
    return d >= now && d <= in30;
  }).length;

  const expired = REQUIREMENTS.filter((r) => r.status === "missing").length;

  return { total, current, requiringAction, expiringSoon, expired };
}

// Lookup helpers
export const getOwner = (id) => OWNERS.find((o) => o.id === id);
export const getProperty = (id) => PROPERTIES.find((p) => p.id === id);
export const getContact = (id) => CONTACTS.find((c) => c.id === id);
export const getDocument = (id) => DOCUMENTS.find((d) => d.id === id);
export const getRequirementsForProperty = (propId) =>
  REQUIREMENTS.filter((r) => r.propertyId === propId);
export const getDocumentsForProperty = (propId) =>
  DOCUMENTS.filter((d) => d.propertyId === propId);
export const getContactsForProperty = (propId) =>
  CONTACTS.filter((c) => c.linkedPropertyIds.includes(propId));

// Status label helper (operational language only)
export const STATUS_LABELS = {
  current: "All registered requirements are current",
  expiring: "Renewal approaching",
  action: "Action required",
  incomplete: "Information incomplete",
};

export const REQ_STATUS_LABELS = {
  current: "Current",
  expiring: "Renewal approaching",
  missing: "Action required",
  na: "Not applicable",
};

export const REQ_STATUS_TONE = {
  current: "green",
  expiring: "amber",
  missing: "red",
  na: "grey",
};

export const PROP_STATUS_TONE = {
  current: "green",
  expiring: "amber",
  action: "red",
  incomplete: "red",
};
